import { render, staticRenderFns } from "./payouts.vue?vue&type=template&id=1d06bd0d&scoped=true"
import script from "./payouts.vue?vue&type=script&lang=js"
export * from "./payouts.vue?vue&type=script&lang=js"
import style0 from "./payouts.vue?vue&type=style&index=0&id=1d06bd0d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d06bd0d",
  null
  
)

export default component.exports